import React, {useContext} from 'react'
import { DataContext } from '../../componets/ContextProvider'
import dreamHome from "../../images/dreamHome.jpg"
import Button from '../../componets/Button'
import { FiMapPin } from 'react-icons/fi';
import { FaBed, FaToilet } from 'react-icons/fa';
import "./Listing.css"
import PropertyFilter from '../../componets/PropertyFilter'
import Modal from '../../componets/Modal'
import Loading from '../../componets/Loading'

const Listing = () => {
    const {
        getPropertyData,
        memorizedPropertiesDetails,
        openModal,
        tour,
        handleSendToWhatsApp,
        setWhatsappMessage,
        whatsappMessage
    } = useContext(DataContext)

  return (
    <section>
        <h2 className="property-head">Properties Listing</h2>

        <div className="property-banner">
            <div className="property-banner-text-container">
              <h2>Find your next dream home</h2>
              <p>We are here to help you find the right place for you and your family</p>
            </div>

            <div className="property-banner-img-container">
              <img src={dreamHome} alt="real" className="property-banner-img"/>
            </div>
        </div>

        <PropertyFilter />

       {memorizedPropertiesDetails.length ? <div className="property-listing-container">
          {memorizedPropertiesDetails.map(data => {
              return <div 
              key={data.id} 
              className="property-list"
              onClick={() => getPropertyData(data)}
              >
              <div className="property-img-container">
                <img src={data.images[0]} className="property-img" alt="real" />
              </div>
              <ul className="property-items">
                <li><b>{data.title.toUpperCase()}</b></li>
                <li><FiMapPin /> {`${data.location.city} ${data.location.state}`}</li>
                <li>&#x20A6;{data.price} million</li>
                <li><FaToilet />: {data.bathrooms} | <FaBed />: {data.bedrooms}</li>
              </ul>
              <div>
                <Button 
                text={"Request for inspection"} 
                handleEvent={(e) =>tour(e,data)}
                className={"property-btn"} />
              </div>
            </div>
          })}
        </div >
        : 
        <Loading />
        }

        {openModal 
        && 
        <Modal 
          text={whatsappMessage} 
          setText={setWhatsappMessage} 
          handleEvent={handleSendToWhatsApp}
         />}
    </section>
  )
}

export default Listing
